import React from 'react'
import CardBlog from '../../component/Other/CardBlog'
import Navbar from '../../component/Other/Navbar'
import Contact from '../../component/Page/Contact'
import Footer from '../../component/Page/Footer'

const Blog = () => {
    const blogData = [
        {
            img: "./../images/blg (1).png",
            title: "How Our Wedding Planners Bring Your Vision to Life",
            date: "March 14, 2023",
            link: "#!"
        },
        {
            img: "./../images/blg (2).png",
            title: "The Importance of Personalization in Wedding Planning",
            date: "March 14, 2023",
            link: "#!"
        },
        {
            img: "./../images/blg (3).png",
            title: "Cost-Saving Tips from Our Wedding Planners",
            date: "March 14, 2023",
            link: "#!"
        },
        {
            img: "./../images/img.png",
            title: "10 Essential Tips for Successfully Planning Your Dream Wedding: A Comprehensive Guide",
            date: "March 14, 2023",
            link: "#!"
        },
        {
            img: "./../images/Image.png",
            title: "How to Select the Best Catering for Your Wedding",
            date: "March 14, 2023",
            link: "#!"
        },
    ]
    return (
        <div className="overflow-hidden">
            <Navbar type={"dark"} />

            <section className="position-relative">
                <div className="container">
                    <div className="text-center mb-5">
                        <h2 className="medium font__size--56 text__50-1024 text__50-sm text__50-xs play">Featured Article</h2>
                        <div className="d-flex align-items-center justify-content-center normal font__size--24 text__24-1024  text-capitalize color__brown">
                            <img src="./../images/Vector 2.png" alt="" />
                            <span className="mx-3">BLOG</span>
                            <img src="./../images/Vector 1.png" alt="" />
                        </div>
                    </div>


                    <div className="row mb-5">
                        {
                            blogData.map((obj, i) => {
                                if (i == 3) {
                                    return <div className="col-md-6 col-lg-8 mb-4">
                                        <CardBlog data={obj} />
                                    </div>
                                } else {
                                    return <div className="col-md-6 col-lg-4 mb-4">
                                        <CardBlog data={obj} />
                                    </div>
                                }
                            })
                        }
                    </div>


                    <div className="text-center">
                        <a href="#!" className="medium font__size--14 text__14-1024 btn btn__outlined--darkgreen color__darkgreen shadow text-capitalize rounded__50 h__white no__opacity pointer" >Load More</a>
                    </div>

                </div>
            </section>

            <Contact />

            <Footer />
        </div >
    )
}

export default Blog